import { Footer } from "@/components/Sidebar/Footer"
import { Header } from "@/components/Sidebar/Header"
import { InboxButton } from "@/components/Sidebar/InboxButton"
import { Nav } from "@/components/Sidebar/Nav"
import { NavItem } from "@/components/Sidebar/NavItem"
import { ProfileMenu } from "@/components/Sidebar/ProfileMenu"
import { SwitchInstanceButton } from "@/components/Sidebar/SwitchInstanceButton"
import { Container } from "@/components/Sidebar/Container"

export const Sidebar = {
	Footer,
	Header,
	InboxButton,
	Nav,
	NavItem,
	ProfileMenu,
	SwitchInstanceButton,
	Container
}
